import { render, staticRenderFns } from "./ZztZhongjianForm.vue?vue&type=template&id=8c841ac4&"
import script from "./ZztZhongjianForm.vue?vue&type=script&lang=js&"
export * from "./ZztZhongjianForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports